/**
 * @file SortDropdown.jsx
 * @description Sıralama dropdown bileşeni
 *
 * İlan listesi için sıralama seçeneği sunar.
 * Seçim değiştiğinde onSortChange callback'i çağrılır.
 *
 * @module widget/components/SortDropdown
 */

import { ChevronDown } from "lucide-react";

/**
 * Sıralama seçenekleri
 * Backend'deki SORT_IDS ile eşleşir (urlBuilder.ts)
 */
const SORT_OPTIONS = [
  { value: "relevance", label: "Önerilen" },
  { value: "price_asc", label: "Fiyat (Artan)" },
  { value: "price_desc", label: "Fiyat (Azalan)" },
  { value: "date_desc", label: "En Yeni" },
  { value: "area_desc", label: "m² (Büyük)" },
];

/**
 * Sıralama Dropdown Bileşeni
 *
 * @component
 * @param {Object} props - Bileşen prop'ları
 * @param {string} props.value - Seçili sıralama değeri
 * @param {Function} props.onSortChange - Sıralama değiştiğinde çağrılır
 * @param {boolean} props.isDark - Karanlık mod
 * @param {boolean} [props.disabled] - Devre dışı durumu
 *
 * @returns {JSX.Element} Dropdown bileşeni
 *
 * @example
 * <SortDropdown
 *   value="price_asc"
 *   onSortChange={(sort) => handleSort(sort)}
 *   isDark={false}
 * />
 */
export function SortDropdown({ value = "relevance", onSortChange, isDark, disabled = false }) {
  const handleChange = (e) => {
    const newValue = e.target.value;
    if (newValue !== value) {
      onSortChange(newValue);
    }
  };

  return (
    <div className="relative inline-flex items-center">
      <select
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={`
          appearance-none cursor-pointer
          text-xs font-medium
          pl-2 pr-6 py-1
          rounded-lg border
          transition-colors
          focus:outline-none focus:ring-1 focus:ring-emerald-500
          ${disabled ? "opacity-50 cursor-not-allowed" : ""}
          ${isDark
            ? "bg-zinc-800 border-white/10 text-white/80 hover:bg-zinc-700"
            : "bg-gray-50 border-black/10 text-black/80 hover:bg-gray-100"
          }
        `}
        aria-label="Sıralama seçin"
      >
        {SORT_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown
        className={`absolute right-1.5 pointer-events-none h-3 w-3 ${
          isDark ? "text-white/50" : "text-black/50"
        }`}
        strokeWidth={2}
      />
    </div>
  );
}

export default SortDropdown;
